import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import TaskIcon from "@mui/icons-material/Task";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import RequestPageRoundedIcon from "@mui/icons-material/RequestPageRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import CopyrightIcon from '@mui/icons-material/Copyright';
import { SIDE_BAR_COMPONENTS } from "../components/v2/dashboard/components/MenuContent";
import { PriorityHighRounded } from "@mui/icons-material";
import { LoginRounded } from "@mui/icons-material";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
export const TICKET_SYSTEM_BASE_URL = "http://localhost:8082";
//export const TICKET_SYSTEM_UI_BASE_URL = "http://localhost:3000";

/* Organizations */
export const ORG_URL = "/api/organizations";
export const ORG_TYPE_URL = "/api/admin/orgtypes/";

/* Notifications */
export const ORG_NOTIFICATION_URL = "/api/org-notification/";
export const NOTIFICATION_TYPE_URL = "/api/notification-type/";

/* Notifications */
export const LICENSE_URL = "/api/license/";

/* Organizations Titles */
export const ORG_TITLE_URL = "/api/organization-titles";

/* Users */
export const USERS_URL = "/api/users";
export const USERS_SEARCH_URL = "/api/users/search/";
export const USER_CHANGE_PASSWORD = "/api/users/change-password";
export const USER_PROFILE_PICTURE = "/api/users/pic";
export const USER_LOAD_PROFILE_PICTURE = "/api/users";
export const USER_DELETE_PROFILE_PICTURE = "/api/users/delete";
export const USER_FORGOT_PASSWORD = "/api/users/forgot-password";

/* Address */
export const USER_ADDRESS_URL = "/api/addresses";
export const USER_ADDRESS_BY_USER_ID_URL = "/api/addresses/user";

/*Countries*/
export const COUNTRY_URL = "/api/countries";

/*States*/
export const STATE_URL = "/api/states";

/* Tickets */
export const TICKET_URL = "/api/ticket";
export const TICKET_UPDATE_URL = "/api/ticket/update";
export const MERGE_TICKETS_URL = "/api/ticket/merge";
export const TICKETS_MERGED_URL = "/api/ticket/merge/";
export const DELETE_MERGED_TICKET_URL = "/api/ticket/merge/delete";
export const TICKET_SLA_CLOCK_URL = "/api/ticket/sla/";
export const TICKET_ASSIGN_USER_URL = "/api/ticket/assign";

export const TICKETS_BY_USER_URL = "/api/ticket/user";
export const TICKETS_BY_RESOLVER_URL = "/api/ticket/resolver";
export const TICKETS_BY_RESOLVER_GROUP_URL = "/api/ticket/rg";
export const TICKET_ALL_URL = "/api/ticket/all";
/* Reports */
export const REPORT_BUILDER_URL = "/api/report";
export const REPORT_DOWNLOAD_BUILDER_URL = "/api/report/download";
export const REPORT_SCHEDULE_URL = "/api/report-schedule/";
export const REPORT_SCHEDULE_UPDATE_URL = "/api/report-schedule/update";
export const REPORT_SCHEDULE_USER_URL = "/api/report-schedule/user";
export const REPORT_SCHEDULE_REPORT_URL = "/api/report-schedule/report/";

export const REPORT_URL = "/api/report/";
export const REPORT_UPDATE_URL = "/api/report/update";
export const REPORT_USER_URL = "/api/report/user";

/* User Tickets */
export const USER_TICKETS_URL = "/api/ticket/user/";
export const TICKETS_URL = "/api/ticket";

/* Department */
export const DEPARTMETNS_URL = "/api/departments";

/* Ticket Category */
export const TICKET_CATEGORIES_URL = "/api/ticket/categories";

/* Source Type*/
export const SOURCE_TYPES_URL = "/api/source-type";

/* Urgency */
export const URGENCIES_URL = "/api/urgency";

/* Impact */
export const IMPACTS_URL = "/api/impact";

/* Priorty */
export const PRIORITIES_URL = "/api/priority";

export const INCIDENT_PRIORITY_URL = "/api/impact-urgency-priority";
export const GET_PRIORITY_BY_URGENCY_IMPACT_URL = "/api/impact-urgency-priority/priority";

/* Request Type */
export const REQUEST_TYPE_URL = "/api/requesttype/";

/* Comment */
export const COMMENT_URL = "/api/ticket/comment";
export const COMMENT_UPDATE_URL = "/api/ticket/comment/update";
export const TICKET_COMMENTS_URL = "/api/ticket/comment/ticket/";

/* Comment */
export const SOLUTION_URL = "/api/solution/";
export const TICKET_SOLUTIONS_URL = "/api/solution/ticket/";

/* Login */
export const AUTH_LOGIN_URL = "/api/auth/login";
export const AUTH_SIGNUP_URL = "/api/auth/signup";

/* Functional Role */
export const FUNCTIONAL_ROLES_URL = "/api/fr/";

/* Role */
export const ROLES_URL = "/api/roles";

/* User Role */
export const USER_ROLES_URL = "/api/user_roles/";
export const USER_ROLES_BY_ROLE_URL = "/api/user_roles/role/";
export const USER_ROLES_BY_USER_URL = "/api/user_roles/user/";
export const USERS_BY_FUNCTIONAL_ROLE = "/api/user_roles/functional/role/";

/* Escalation */
export const ESCALATION_URL = "/api/escalation/";
export const ESCALATION_BY_SLA_URL = "/api/escalation/sla/";
export const ESCALATION_UPDATE_URL = "/api/escalation/update";
export const ESCALATION_USER_ESCALATION_ROLES_URL = "/api/escalation/user";

/* Module */
export const MODULE_URL = "/api/module/";

/* API Permission */
export const API_PERMISSION_URL = "/api/api-permission/";
export const API_PERMISSION_SECRET_URL = "/api/api-permission/secrets";


/* Role Screens*/
export const ROLES_SCREENS_URL = "/api/role-screens";
export const ROLES_SCREENS_BY_ROLE_URL = "/api/role-screens/role";

export const SCREENS_URL = "/api/admin/screens/";

/* Status */
export const STATUS_URL = "/api/status/";
export const STATUS_BY_ID_URL = "/api/status/id/";

/* Group Types */
export const GROUP_TYPE_URL = "/api/grouptype/";

/* Resolver Group */
export const RESOLVER_GROUP_URL = "/api/resolver-groups";
export const RESOLVER_GROUP_BY_TICKET_CATEGORY_URL =
  "/api/resolver-groups/ticket-categories";

/* Resolver */
export const RESOLVER_URL = "/api/resolver";
export const RESOLVER_BY_RG_URL = "/api/resolver/resolver-group";
export const RESOLVER_BY_USER_URL = "/api/resolver/user";
export const RESOLVER_GROUPS_USER_URL = "/api/resolver/resolver-group/user";
/* Asset Item */
export const ASSET_ITEM_URL = "/api/asset/item";
export const ASSET_ITEM_DTO_URL = "/api/asset/item/dto";

/* Asset Attachment */
export const ASSET_ATTACHMENT_URL = "/api/asset/attachment";
export const ASSET_ATTACHMENTS_BY_ITEM_URL = "/api/asset/attachment/item";

/* Asset Description */
export const ASSET_DESC_URL = "/api/asset/desc/";
export const ASSET_DESC_BY_AI_URL = "/api/asset/desc/ai/";

/* Asset Configuration */
export const ASSET_CONFIG_URL = "/api/asset/config/";
export const ASSET_CONFIG_BY_AI_URL = "/api/asset/config/ai/";


/* Attachment */
export const ATTACHMENT_URL = "/api/attachment";
export const TICKET_ATTACHMENTS_URL = "/api/attachment/ticket/";

/* Activity */
export const TICKET_ACTIVITY_URL = "/api/user/activities/";

/* Asset Class */
export const ASSET_CLASS_URL = "/api/asset/class";
export const ASSET_CLASS_DOWNLOAD_URL = "/api/asset/class/attachment";

/* Asset Type */
export const ASSET_TYPE_URL = "/api/asset/type";
export const ASSET_TYPE_CLASS_URL = "/api/asset/type/class";
export const ASSET_TYPE_DOWNLOAD_URL = "/api/asset/type/attachment";

/* Change Request */

export const CHANGE_REQUEST_URL = "/api/changes";
export const CHANGE_STATUS_URL = "/api/change-status";
export const CHANGE_ACTIVITY_URL = "/api/change-activities";

/* SLA */
export const SLA_URL = "/api/sla/";
export const SLA_BUSINESS_URL = "/api/sla/business";
export const SLA_EXIST_URL = "/api/sla/exist";

/* Operational hours */
export const OPERATIONAL_HOURS_URL = "/api/oh/";

export const RESPONSE_RESOLVE_URL = "/api/response-resolve/";

export const RESPONSE_RESOLVE_BY_SLA_URL = "/api/response-resolve/sla/";
export const RESPONSE_RESOLVE_BY_PRIORITY_URL = "/api/response-resolve/priority/";

export const EMAIL_URL = "/api/email";
export const EMAILS_BY_TICKET_ID_URL = "/api/email/ticket/";
export const EMAIL_ATTACHMENT_URL = "/api/email/";

export const EMAIL_INGETION = "api/email-ingetion";
export const EMAIL_INGETION_MARK_READ = "api/email-ingetion/mark-read/";
export const EMAIL_INGETION_USER_BY_EMAIL = "api/email-ingetion/email/";


export const CATEGORY_URL = "/api/categories";
export const SUB_CATEGORY_URL = "/api/solution/subcategories";
export const SUB_CATEGORY_BY_CAT_URL = "/api/solution/subcategories/cat/";

/* Import data */
export const IMPORT_URL = "/api/import";
export const IMPORT_TABLES_URL = "/api/import/tables";

/* Asset Status */
export const ASSET_STATUS_URL = "/api/asset-status";

export const ASSET_DISABLE_METHODS_URL = "/api/asset-disposal-methods";
export const ASSET_ASSIGNMENT_TYPES_URL = "/api/asset-assignment-types";
export const ASSET_WAREHOUSE_URL = "/api/warehouses";
export const ASSET_LOST_TYPE_URL = "/api/asset-lost-types";
export const ASSET_MAINTENANCE_TYPE_URL = "/api/asset-maintenance-types";
export const CONFIGURATION_CATEGORY_URL = "/api/configuration/categories";
export const CONFIGURATION_ENVIRONMENT_URL = "/api/configuration/environments";
// export const CONFIGURATION_SUPPORT_GROUP_URL = "/api/configuration/support-groups";

export const CONFIGURATION_ITEM_URL = "/api/configuration-items";
export const CONFIGURATION_RELATIONSHIP_URL = "/api/configuration/relationships";
export const CONFIGURATION_ITEM_HISTORY_URL = "/api/configuration-item";


export const MAINTENANCE_WINDOW_URL = "/api/maintenance-windows";
export const AFFECTED_SERVICES_URL = "/api/affected-services";
export const CHANGE_TYPE_URL = "/api/change-types";


/* Brand */

export const BRAND_URL = "/api/brand/";

/* Article */

export const ARTICLE_URL = "/api/solution/article";
export const ARTICLE_RATING_URL = "/api/article_rating/";
export const ARTICLE_REFERENCE_URL = "/api/article_reference_url/";
export const ARTICLE_ATTACHMENT_URL = "/api/article_attachment/";

/* SMTP */
export const SMTP_URL = "/api/smtp/";

/* SSO */
export const SSO_URL = "/api/saml/";

/* Global Configuration */
export const Configuration_URL = "/api/config/";

/* Feedback */
export const FEEDBACK_URL = "/api/feedback/";
export const TICKET_FEEDBACK_URL = "/api/feedback/ticket/";

/* Tasks */

export const TASKS_URL = "/api/task";
export const TASKS_UPDATE_URL = "/api/task/update";
export const TASKS_ALL_URL = "/api/task/all";
export const TASKS_ALL_BY_USER_URL = "/api/task/user";
export const TASK_COMMENTS_URL = "/api/task/comment";
export const TASK_COMMENTS_BY_TASK_URL = "/api/task/comment/task";
export const TASKS_ACTIVITY_URL = "/api/task/activities";

export const TASKS_SCHEDULE_URL = "api/task-schedule/";
export const TASKS_SCHEDULE_SEARCH_URL = "api/task-schedule/search";
export const TASKS_SCHEDULE_UPDATE_URL = "api/task-schedule/update";

/* Home */
export const HOME_MY_TICKETS_COUNT = "/api/home/my-tickets/";
export const HOME_ASSIGNED_TICKETS_COUNT = "/api/home/assigned-tickets/";
export const HOME_RESOLVED_GROUPS_TICKETS_COUNT = "/api/home/resolver-group-tickets/";
export const HOME_SLA_ABOUT_REACHED_TICKETS_COUNT = "/api/home/sla-to-be-breached";
export const HOME_RECENT_ACTIVITIES = "/api/home/recent-activities";

/* Dashboard */
export const CATEGORY_TICKET_COUNT = "/api/dashboard/category-count";
export const STATUS_TICKET_COUNT = "/api/dashboard/status-count";
export const TICKETS_LAST30DAYS_TREDND = "/api/dashboard/monthly-trend";
export const TICKETS_CLOSED_TREDND = "/api/dashboard/closed-tickets";
export const TICKETS_UNASSIGNED_TREDND = "/api/dashboard/un-assigned";
export const TICKETS_AGING_TREDND = "/api/dashboard/aging-tickets";
export const TICKETS_STATUS_TREDND = "/api/dashboard/tickets-status";

export const TICKETS_CUSTOMER_SURVEY = "/api/dashboard/customer-feedback";
export const TICKETS_SLA_STATUS = "/api/dashboard/sla-status";
export const TICKETS_ESCALATED_STATS = "/api/dashboard/escalated-stats";
export const TICKETS_SLA_COMPLIANCE = "/api/dashboard/sla-compliance";


/* AI */
export const AI_API_URL = "https://openrouter.ai/api/v1/chat/completions";
export const AI_API_KEY =
  "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";

export const ROUTES = {
  LOGIN: "/login",
  HOME: "/home",
  DASHBOARD: "/dashboard",
  TICKETS: "/tickets",
  EDIT_TICKET: "/editTicket/:viewTicketId",
  CONTACT: "/contact",
  ADMIN: "/admin",
  SETTINGS: "/settings",

  ASSETS: "/assets",
  SOLUTIONS: "/solutions",
  USERS: "/users",
  ROLES: "/roles",
  REQUEST_TYPES: "/request-types",
  URGENCY: "/urgency",
  IMPACT: "/impact",
  PRIORITY: "/priority",
  RESOLVER_GROUPS: "/resolver-groups",
  RESOLVER: "/resolver",
  REPORTS: "/reports",
  ABOUT: "/about",
  TASKS: "/tasks",
  CHANGE: "/change",
  CI: "/configItem",
  QUEUE: "/queue",
  UNAUTHORIZED: "/unauthorized",
  DEPARTMENTS: "/departments",
};
export const DEFAULT_NAV_TITLE = "default"; //this is used for dynamic routes like /editTicket/:viewTicketId

// Please define the navigation titles for each route here.
// if its' a dynamic route, then use the DEFAULT_NAV_TITLE as key and pass a function that returns the component to render
export const ROUTE_TO_NAV_TITLES_MAP = {
  [ROUTES.LOGIN]: {
    label: "Login",
    path: "/login",
    icon: <LoginRounded sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Login",
  },
  [ROUTES.HOME]: {
    label: "Home",
    path: "/home",
    icon: <HomeRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Home",
  },
  [ROUTES.DASHBOARD]: {
    label: "Dashboard",
    path: "/dashboard",
    icon: <GridViewRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Dashboard",
  },
  [ROUTES.TICKETS]: {
    label: "Tickets",
    path: "/tickets",
    icon: <ConfirmationNumberIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Tickets",
  },
  "/editTicket": {
    [DEFAULT_NAV_TITLE]: (ticketId) => {
      return [
        ROUTE_TO_NAV_TITLES_MAP[ROUTES.TICKETS],
        {
          clickable: false,
          label: `#${ticketId}`,
        },
      ];
    },
  },
  [ROUTES.CONTACT]: {
    label: "Contact",
    path: "/contact",
    icon: <HelpRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Contact",
  },
  [ROUTES.ADMIN]: {
    label: "Administration",
    path: "/admin",
    icon: <PeopleRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Administration",
  },
  [ROUTES.SETTINGS]: {
    label: "Settings",
    path: "/settings",
    icon: <SettingsRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Settings",
  },

  [ROUTES.ASSETS]: {
    label: "Assets",
    path: "/assets",
    icon: <CurrencyExchangeIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Assets",
  },
  [ROUTES.CI]: {
    label: "CMDB",
    path: "/ci",
    icon: <CopyrightIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Configuration Item",
  },
  [ROUTES.SOLUTIONS]: {
    label: "Solutions",
    path: "/solutions",
    icon: <TipsAndUpdatesIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Solutions",
  },
  [ROUTES.USERS]: {
    label: "Users",
    path: "/users",
    icon: <PeopleRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Users",
  },
  [ROUTES.ROLES]: {
    label: "Roles",
    path: "/roles",
    icon: <SecurityRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Roles",
  },
  [ROUTES.REQUEST_TYPES]: {
    label: "Request Types",
    path: "/request-types",
    icon: <RequestPageRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Request Types",
  },
  [ROUTES.URGENCY]: {
    label: "Urgency",
    path: "/urgency",
    icon: <PriorityHighRounded sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Urgency",
  },
  [ROUTES.IMPACT]: {
    label: "Impact",
    path: "/impact",
    icon: <InfoRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Impact",
  },
  [ROUTES.PRIORITY]: {
    label: "Priority",
    path: "/priority",
    icon: <PriorityHighRounded sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Priority",
  },
  [ROUTES.RESOLVER_GROUPS]: {
    label: "Resolver Groups",
    path: "/resolver-groups",
    icon: <GroupRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Resolver Groups",
  },
  [ROUTES.RESOLVER]: {
    label: "Resolver",
    path: "/resolver",
    icon: <PersonRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Resolver",
  },
  [ROUTES.REPORTS]: {
    label: "Reports",
    path: "/reports",
    icon: <BarChartRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Reports",
  },
  [ROUTES.ABOUT]: {
    label: "About Us",
    path: "/about",
    icon: <InfoRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to About Us",
  },
  [ROUTES.TASKS]: {
    label: "Tasks",
    path: "/tasks",
    icon: <TaskIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Tasks",
  },
  [ROUTES.CHANGE]: {
    label: "Change",
    path: "/change",
    icon: <ChangeCircleIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Change",
  },
  [ROUTES.QUEUE]: {
    label: "Queue",
    path: "/queue",
    icon: <TaskIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Queue",
  },
  [ROUTES.UNAUTHORIZED]: {
    label: "Unauthorized Access",
    path: "/unauthorized",
    icon: <LockRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Unauthorized Access",
  },
  [ROUTES.DEPARTMENTS]: {
    label: "Departments",
    path: "/departments",
    icon: <BusinessRoundedIcon sx={{ fontSize: 18 }} />,
    clickable: true,
    tooltip: "Go to Departments",
  },
};
